<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 140px">{{ $t('landingPage.settingFirstView.nameCampaign') }} </label>
                    <div class="col-sm-10">
                        {{ firsViewForm?.campaign?.name ?? '' }}
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 140px">{{ $t('landingPage.settingFirstView.detailFirstView') }} </label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="firsViewForm.image"
                            :id="`FirstViewImage`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('landingPage.noteImageBeautiful') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 140px">{{ $t('landingPage.settingFirstView.finishedFirstView') }} </label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="firsViewForm.finished_image"
                            :id="`finishedFirstView`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('landingPage.noteImageBeautiful') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { validateField } from '@/utils/validate';
import { editorMethods } from '@/state/helpers';
import { IMAGE_EXTENSIONS } from '@/utils/format';
import { cloneDeep } from 'lodash';

import UploadImageCommon from '@/components/Uploads/Image/main.vue';

export default {
    name: 'SettingFirstViewAndTimeApplication',
    components: {
        UploadImageCommon
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            firsViewForm: cloneDeep(this.dataForm),
            arrExtension: IMAGE_EXTENSIONS
        };
    },
    computed: {},
    methods: {
        ...editorMethods,

        handleValidateField(configField) {
            validateField(configField);
        }
    },

    watch: {
        firsViewForm: {
            handler(newFirsViewForm) {
                this.$emit('update:dataForm', newFirsViewForm);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
